import React from 'react';

function FloatingImage({ src, uid, animationDuration, fromValue, toValue, style }) {
	const stl = {
		animationDuration: `${animationDuration}ms`,
		animationName: uid,
		animationTimingFunction: 'linear',
		animationIterationCount: 'infinite',
		animationDirection: 'alternate',
		transformOrigin: 'center',
	};

	const keyframes = `
    @keyframes ${uid} {
      from {
        transform: translateY(${fromValue}px);
      }
      to {
        transform: translateY(${toValue}px);
      }
    }
  `;

	return (
		<>
			<style>{keyframes}</style>
			<img style={Object.assign({}, stl, style)} src={src} alt="" />
		</>
	)
}

export default FloatingImage;
